import { useQuery } from '@tanstack/react-query';
import { queryKeys } from 'queryKeys';
import userService from 'services/user';
import { IS_PROD } from 'settings';

import { type CurrentUser } from '@eduzz/ui-layout/Topbar/HyperflowSupportChat/types';

export function useHyperflowJwtQuery(userToHyperflow: CurrentUser) {
  return useQuery({
    queryKey: queryKeys.layout.hyperflowJwt(userToHyperflow.id),
    queryFn: async () => {
      const hyperflowJwt = await userService.createHyperflowToken(userToHyperflow);
      const hyperflowChatToken = hyperflowJwt?.data?.hyperflowToken;

      if (!hyperflowChatToken) {
        throw new Error('JWT not created or empty');
      }

      return hyperflowChatToken as string;
    },
    enabled: !!userToHyperflow.id && IS_PROD,
    staleTime: Infinity,
    retry: false
  });
}
